// This component has been added ad-hoc by sales-leader-insights-fe team: https://private.hubteam.com/janus/groups/hs-sales-leader-insights-fe
// For any questions/concerns, please use Slack channel: #sales-leader-insights-fe

import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
const portalId = PortalIdParser.get();
const getTranscriptSettingsUrl = () => {
  return `${getFullUrl('app')}/settings/${portalId}/calling/callconfigurations?eschref=${encodeURIComponent(window.location.pathname)}`;
};
export default getTranscriptSettingsUrl;